import React from 'react';
import MaterialTable from 'material-table';
import { collection, query } from 'firebase/firestore';
import { Box, Container } from '@material-ui/core';
import { useFirestoreCollectionData } from 'reactfire';
import { useFirestore } from 'reactfire';
import { doc, setDoc } from 'firebase/firestore'; 
import Page from 'src/components/Page';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { v4 as uuid } from 'uuid';
import { useAlertContext } from 'src/context/AlertContext';
import {useLocation } from 'react-router-dom';

interface copyNewUserLinkType {
  id:string,
  name:string,
  group?:number,
  team?:number,
  order?:number,
  role?:string,
  newUser:boolean
}
export const UserTable = () => {
  type IType =
    | 'string'
    | 'boolean'
    | 'numeric'
    | 'date'
    | 'datetime'
    | 'time'
    | 'currency';
  const string: IType = 'string';


  const db = useFirestore();
  const usersQuery = query(
    collection(db, 'users'));
  const { data } = useFirestoreCollectionData(usersQuery, {
    idField: 'id', // this field will be added to the object created from each document
  });
  const location = useLocation();

  const {useErrorAlert, useAlert} = useAlertContext();

  const copyNewUserLink = (rowData:copyNewUserLinkType)=>{
    // return `${window.location.origin.toString()}/register/${rowData.id}`;
    return rowData.id;
  };
  return (
    <Page title="Users Management">
      <Box p={3}>
        <Container>
          <MaterialTable
            title="Users Management"
            columns={[
              { title: 'Name', 
                field: 'name', 
                type: 'string' as const ,
                // editable:'onAdd'
              },
              {
                title: 'Group',
                field: 'group',
                align:'left',
                defaultSort:'asc',
                type: 'numeric' as const,
              },
              {
                title: 'Team',
                field: 'team',
                align:'left',
                type: 'numeric' as const
              },
              {
                title: 'Order',
                field: 'order',
                align:'left',

                hiddenByColumnsButton:true,
                type: 'numeric' as const
              },
              {
                title: 'Role',
                field: 'role',
                lookup: { member: 'Member' , tjn: 'Team Leader', gyjn: 'Group Leader', sgyjn: 'Sub-Group Leader', temp: 'Temp',teacher: 'Teacher', admin: 'Admin' },
                type: 'string' as const
              },
              {
                title: 'Invitation Code',
                field: 'newUser',
                align:'left',
                editable:'never',
                render: rowData => <div>
                  {rowData['newUser']?(
                    <CopyToClipboard text={copyNewUserLink({...rowData} as copyNewUserLinkType)}>
                      <div
                        onClick={() => {
                          useAlert('Your have copied the share link to clipboard','success');
                        }}
                      >
                        {rowData['id']}
                      </div>
                      {/* <Button
                        color="secondary"
                        variant="contained"
                        // startIcon={<ContentCopyIcon/>}
                        style={{
                          width: '100%',
                          marginTop:8,
                          color: 'white',
                          lineHeight: 1.2
                        }}
                        // onClick={() => alert("This feature is in maintaince")}
                        onClick={() => {
                          useAlert('Your have copied the share link to clipboard','success');
                        }}
                      >
                        Invitation Code
                      </Button> */}
                    </CopyToClipboard>
                  ):''} </div>,
                type: 'boolean' as const
              },
              { title: 'Telegram', 
                field: 'telegramId', 
                type: 'numeric' as const ,
                editable:'never'
              },
            ]}
            data={data}
            options={{
              pageSize:20,
              grouping: true,
              exportButton: true,
              paginationType:'stepped',
              columnsButton:true
            }}
            editable={{
              onRowAdd: newData => {
                const userId = uuid();
                return setDoc(doc(db, 'users', `${userId}`), {...newData,newUser:userId});
              },
              onBulkUpdate: changes => new Promise((resolve, reject) => {
                const allPromise = Object.keys(changes).map(objKey=>{
                  return setDoc(doc(db, 'users', changes[+objKey].newData.id), changes[+objKey].newData);
                });
                return Promise.all(allPromise)
                  .then(resolve)
                  .catch(reject);
              }),
              onRowUpdate: (newData) =>
         
                setDoc(doc(db, 'users', newData.id), newData)
            }}
          />
        </Container>
      </Box>
    </Page>
  );
};


//https://codesandbox.io/s/hc0fw?file=/src/App.tsx